import { X } from "lucide-react";

const inputCls = "mt-1.5 w-full border border-line bg-ink px-3 py-2.5 text-sm text-white outline-none transition-colors focus:border-signal";
const labelCls = "font-mono text-[9px] uppercase tracking-[0.2em] text-muted";

export function Field({ label, children }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      {children}
    </div>
  );
}

export function TextInput(props) {
  return <input {...props} className={inputCls} />;
}

export function ModalShell({ title, onClose, children, wide = false }) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/70 p-4 backdrop-blur-sm sm:p-10" data-testid="admin-modal">
      <div className={`w-full ${wide ? "max-w-3xl" : "max-w-lg"} border border-line bg-surface`}>
        <div className="flex items-center justify-between border-b border-line px-6 py-4">
          <h2 className="font-mono text-xs font-600 uppercase tracking-[0.25em] text-white">{title}</h2>
          <button onClick={onClose} data-testid="modal-close-btn" className="text-muted transition-colors hover:text-white" aria-label="Close">
            <X size={18} />
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

export function DeleteButton({ onConfirm, testId }) {
  const [armed, setArmed] = useStateLocal(false);
  return (
    <button
      data-testid={testId}
      onClick={() => {
        if (armed) {
          setArmed(false);
          onConfirm();
        } else {
          setArmed(true);
          setTimeout(() => setArmed(false), 3000);
        }
      }}
      className={`border px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] transition-colors ${
        armed ? "border-loss bg-loss text-white" : "border-loss/40 text-loss/80 hover:border-loss hover:text-loss"
      }`}
    >
      {armed ? "Confirm?" : "Delete"}
    </button>
  );
}

import { useState as useStateLocal } from "react";
